import api from '@/api';
import { QuestAccountsReceivableRequest } from './AccountsReceivable.types';
import { API_BASE_URL } from '../../index';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportAccountsReceivable(
  params: QuestAccountsReceivableRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/AccountsReceivable`,
    params,
  )) as unknown;

  return result as BlobPart;
}
